import Vue from 'vue'
import VueI18n from 'vue-i18n'
import vi from './vi'
import en from './en'

Vue.use(VueI18n)

const messages = {
  'vi': vi,
  'en': en,
}

const i18n = new VueI18n({
  locale: 'en',
  messages,
  fallbackLocale: 'en'
})

export default i18n
